import CountUp from "react-countup";
import MotionStagger from "../common/Motion/MotionStagger";
import MotionItem from "../common/Motion/MotionItem";

function StatsBar() {
  const stats = [
    { value: 2500, suffix: "+", label: "Certified Professionals Deployed", count: true },
    { value: 44, suffix: "+", label: "Active Rigs Supported Across India", count: true },
    { value: "24/7", label: "Operational Support Capability", count: false },
    { value: "ISO", label: "9001 · 45001 · 14001 Certified", count: false },
    { value: "IADC", label: "Member", count: false },
    { value: "2014", label: "Established", count: false },
  ];

  return (
<MotionStagger
  as="section"
  className="relative z-20 mt-0 lg:-mt-28"
>      <div className="max-w-7xl mx-auto px-6 relative">
<div className="overflow-hidden rounded-3xl bg-white shadow-[0_25px_60px_rgba(0,0,0,0.18)] grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
          {stats.map((item, index) => (
            <MotionItem
              key={item.label}
              variant="scaleIn"
              className={`p-5 sm:p-6 text-center ${
                index < stats.length - 1
                  ? "border-b border-r border-slate-100 max-md:even:border-r-0 md:border-b-0"
                  : ""
              }`}
            >
              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-red-600">
                {item.count ? (
                  <>
                    <CountUp end={item.value} duration={2.5} />
                    {item.suffix}
                  </>
                ) : (
                  item.value
                )}
              </h3>
              <p className="mt-2 text-slate-600 text-xs sm:text-sm leading-snug">{item.label}</p>
            </MotionItem>
          ))}
        </div>
      </div>
    </MotionStagger>
  );
}

export default StatsBar;
